import { Component } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-data-import-popup',
    templateUrl: './data-import-popup.component.html',
    styleUrls: ['./data-import-popup.component.scss'],
    standalone: false
})
export class DataImportPopupComponent {
  constructor(private modalRef: ModalOverlayRef) {
    this.modalRef.backgroundClicked();
  }

  public close() {
    this.modalRef.close();
  }
}
